<template>
  <v-col>
    <v-row :justify="admin ? 'space-between' : 'end'" class="mx-0 mb-1">
      <delete-button
        v-if="admin"
        quiet
        headline="Delete Route?"
        :disabled="routeInQuote"
        disabledText="Route used in a quote. Cannot delete."
        :ondelete="deleteRoute"
      />
      <save-button :onsave="saveRoute" />
    </v-row>
    <v-row>
      <v-col>
        <RouteInfo />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import RouteInfo from "@/modules/routes/components/RouteInfo";

export default {
  components: {
    RouteInfo,
  },
  data() {
    return {
      routeInQuote: false,
    };
  },
  computed: {
    admin() {
      return this.$store.getters["isAdmin"];
    },
  },
  methods: {
    deleteRoute() {
      return this.$store
        .dispatch("RouteStore/deleteRoute")
        .then((v) => {
          this.$root.$success("Deleted Route");
          this.$router.push({
            name: "database_view",
            params: {
              view: "routes",
              sub: "ALL",
            },
          });
        })
        .catch((err) => this.$root.$error(err));
    },
    saveRoute() {
      return this.$store
        .dispatch("RouteStore/updateRoute")
        .then((v) => this.$root.$success("Updated Route"))
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    const routeId = this.$store.getters["RouteStore/id"] || this.$route.params.id;
    this.$store
      .dispatch("RouteStore/checkRouteInQuote", routeId)
      .then((val) => {
        this.routeInQuote = !!val.count;
      })
      .catch((err) => this.$root.$error(err));
  },
  beforeDestroy() {
    if (this.$store.getters["RouteStore/hasChanges"]) {
      this.saveRoute();
    }
  },
};
</script>
